import TotalEarningComponent from "../../Component/IncomeReport/TotalEarningComponent"

const TotalEarning = () => {
  return (
    <div className='page-body'>
      <TotalEarningComponent />
    </div>
  )
}

export default TotalEarning